import React from 'react';
import {
  Box,
  TextField,
  Button,
  DialogContent,
  DialogActions,
  Dialog,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid
} from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTechnicians } from '../../contexts/TechniciansContext';
import TechnicianSkillSelect from './TechnicianSkillSelect';

const validationSchema = yup.object({
  firstName: yup.string()
    .required('Le prénom est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères'),
  lastName: yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  email: yup.string()
    .email('Email invalide')
    .required('L\'email est requis'),
  phone: yup.string()
    .matches(/^[0-9+ -]{10,}$/, 'Numéro de téléphone invalide')
    .required('Le numéro de téléphone est requis'),
  skills: yup.array()
    .min(1, 'Au moins une compétence est requise')
    .required('Les compétences sont requises')
});

const TechnicianForm = ({ technician, onClose, onSuccess }) => {
  const { addTechnician, updateTechnician } = useTechnicians();

  const formik = useFormik({
    initialValues: {
      firstName: technician?.firstName || '',
      lastName: technician?.lastName || '',
      email: technician?.email || '',
      phone: technician?.phone || '',
      skills: technician?.skills || []
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        if (technician?.id) {
          await updateTechnician(technician.id, values);
        } else {
          await addTechnician(values);
        }
        if (onSuccess) {
          onSuccess();
        }
        onClose();
      } catch (error) {
        console.error('Erreur lors de l\'enregistrement du technicien:', error);
      }
    }
  });



  return (
    <>
      <DialogContent>
        <Box component="form" onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="firstName"
                name="firstName"
                label="Prénom"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
                margin="normal"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="lastName"
                name="lastName"
                label="Nom"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
                margin="normal"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="email"
                name="email"
                label="Email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                margin="normal"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="phone"
                name="phone"
                label="Téléphone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
                margin="normal"
              />
            </Grid>
            

            
            <Grid item xs={12}>
              <TechnicianSkillSelect
                value={formik.values.skills}
                onChange={(e) => formik.setFieldValue('skills', e.target.value)}
                error={formik.touched.skills && Boolean(formik.errors.skills)}
                helperText={formik.touched.skills && formik.errors.skills}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>
          Annuler
        </Button>
        <Button 
          onClick={formik.handleSubmit}
          variant="contained" 
          color="primary"
        >
          {technician?.id ? 'Modifier' : 'Ajouter'}
        </Button>
      </DialogActions>
    </>
  );
};

export default TechnicianForm;